import { api } from 'lib/axios'
import configs from 'config/environment'

const ENDPOINT = '/Api/V8/custom/portal/log-frontend-redux-state'

// Marks the endpoint so axios interceptors / future retry logic can identify
// logger traffic and avoid logging it (which would create infinite loops).
const LOGGER_HEADERS = {
  'Content-Type': 'application/json',
  'X-Redux-Logger': '1'
}

/**
 * POSTs a batch of redux-action logs through the standard authenticated axios
 * client. Always returns a resolved promise — failures are swallowed because a
 * broken logger must never bubble up to the UI.
 */
export const sendReduxActionLogs = logs => {
  if (!Array.isArray(logs) || logs.length === 0) return Promise.resolve()
  return api
    .post(ENDPOINT, { logs },)
    .catch(() => { })
}

/**
 * Page-unload variant. Uses fetch with `keepalive: true` so the browser is
 * allowed to finish the request after the page is gone. We can't reuse the
 * axios client here because most browsers cancel its XHRs on unload.
 */
export const sendReduxActionLogsBeacon = logs => {
  if (!Array.isArray(logs) || logs.length === 0) return
  try {
    const token =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem('access_token')
        : null
    const url = `${configs.apiUrl}${ENDPOINT}`
    fetch(url, {
      method: 'POST',
      keepalive: true,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ logs })
    }).catch(() => { })
  } catch {
    // best-effort
  }
}
